import { Timezone, TourItemType } from '@bb/domain/dist/types';
import { TourItemContent } from 'api/TourController/types';
import { ListItem, Text, ListItemMeta, ListingImage } from 'components';
import React from 'react';
import styled from 'styled-components';
import { createFormatDateFunction } from 'utils';
import StopThumbnail from '../TourSideNav/StopThumbnail';

const timeFormatter = (time: Date, timezone: Timezone) => {
  const formatter = createFormatDateFunction('h:mm aaa');
  return formatter(time, timezone).replace(' ', '');
};

interface TimeNoLongerAvailableModalProps {
  item: TourItemContent;
  isWithoutCoords?: boolean;
}

const TimeNoLongerAvailableItem: React.FC<TimeNoLongerAvailableModalProps> = ({
  item: {
    time,
    timeEnd,
    timezone,
    thumbnail,
    locationName,
    address,
    appointmentId,
    type,
  },
  isWithoutCoords,
}) => {
  const startTime = timeFormatter(time, timezone);
  const endTime = timeFormatter(timeEnd, timezone);
  return (
    <StyledListItem>
      <ListItemMeta
        avatar={
          appointmentId || type === TourItemType.APPOINTMENT ? (
            <ListingImage imageSrc={thumbnail} size={36} />
          ) : (
            <StopThumbnail />
          )
        }
        title={
          <StyledTitleContainer>
            <StyledText ellipsis>{locationName ?? address}</StyledText>
          </StyledTitleContainer>
        }
        description={
          isWithoutCoords ? undefined : <div>{`${startTime} - ${endTime}`}</div>
        }
      />
    </StyledListItem>
  );
};

export default TimeNoLongerAvailableItem;

const StyledListItem = styled(ListItem)`
  margin: 0;
`;

const StyledText = styled(Text)`
  white-space: nowrap;
  margin: 0;
`;

const StyledTitleContainer = styled.div`
  display: flex;
  justify-content: space-between;
  position: relative;
  cursor: pointer;
`;
